export const TourCatalogRoutes = {
  INDEX: "/settings/tour-catalog",
} as const;
